import {
  ref,
  reactive,
  onBeforeMount,
  getCurrentInstance,
  watch,
  computed,
} from "@vue/composition-api";
import router from "@/router";
import store from "@/store";
import useDate from "@/utils/hooks/useDate";
import usePagination from "@/views/components/pagination/usePagination";
import useFilterHeaderTable from "@/views/components/filter-header-table/useFilterHeaderTable";
import useValidationModal from "@/@core/components/base-modal/hooks/useValidationModal";
import { uploadPointModel } from "@/models/ais-point/upload-point";

export default function useUploadPointList() {
  const { resolveDateWithSeperator, resolveTime } = useDate();

  const { pagination, onPageChange, onFilterEntity } = usePagination();

  const {
    filters,
    ordering,
    onSetValueSearch,
    sortingChanged,
    onSelectFilter,
  } = useFilterHeaderTable();

  const {
    openSuccessModal,
    openDefaultErrorModal,
    openErrorModal,
    openWarningModal,
  } = useValidationModal();

  const {
    getCampaignListModel,
    deleteCampaignModel,
    actionCampaignModel,
  } = uploadPointModel();

  const loading = reactive({
    tableData: false,
  });

  const optionData = reactive({
    upoladPointList: [],
  });

  const fields = [
    { key: "seq", label: "No." },
    { key: "campaign_name", label: "Campaign Name" },
    { key: "alt_reference", label: "Campaign Reference" },
    { key: "total_point", label: "Total Point", sortable: true },
    { key: "upload_dt", label: "Upload Time", sortable: true },
    { key: "progress", label: "Progress", sortable: true },
    { key: "status", label: "Status", sortable: true },
    { key: "upload_by", label: "Upload By" },
    { key: "approval_by", label: "Approval By" },
    { key: "status", label: "Status" },
    { key: "actions", label: "" },
  ];

  const resolveUploadPointStatus = (status) => {
    switch (status) {
      case 1:
        return "Draft";
      case 2:
        return "Await Approval";
      case 5:
        return "In Progress";
      case 9:
        return "Success";
      case 11:
        return "Reject";
      default:
        return "-";
    }
  };

  const resolveClassUploadPointStatus = (status) => {
    switch (status) {
      case 1:
        return "draft";
      case 2:
        return "await-approval";
      case 5:
        return "in-progress";
      case 9:
        return "success";
      case 11:
        return "reject";
      default:
        return "-";
    }
  };

  const statusOption = ref([
    { label: "Success", value: 9 },
    { label: "Await Approval", value: 2 },
    { label: "In Progress", value: 5 },
    { label: "Drafted", value: 1 },
    { label: "Reject", value: 11 },
  ]);

  const status = reactive({
    SUCCESS: 9,
    AWAIT_APPROVAL: 2,
    IN_PROGRESS: 5,
    DRAFTED: 1,
    REJECT: 11,
  });

  const draftActionList = reactive({
    edit: {
      label: "Edit",
      value: 1,
      icon: "EditIcon",
      display: true,
    },
    delete: {
      label: "Delete",
      value: 2,
      icon: "DeleteIcon",
      display: true,
    },
  });

  const successActionList = reactive({
    history: {
      label: "History",
      value: 3,
      icon: "DownloadIcon",
      display: true,
    },
  });

  const resolveMappingTableAction = (type, item) => {
    switch (type) {
      case draftActionList.edit.value:
        router.push(
          `/point-exchange/upload-point/upload-point-info/${item.item.campaign_id}`
        );
        return;
      case draftActionList.delete.value:
        fetchDeleteCampaign(item.item);
        return;
      case successActionList.history.value:
        router.push(
          `/point-exchange/upload-point/upload-point-info/${item.item.campaign_id}`
        );
        return;
      default:
    }
  };

  const campaignListTable = reactive({
    payload: [],
  });

  const fetchCampaignList = () => {
    loading.tableData = true;
    getCampaignListModel.payload.Page = pagination.currentPage;
    getCampaignListModel.payload.Limit = pagination.perPage;
    getCampaignListModel.payload.Filters = filters;
    getCampaignListModel.payload.Ordering = ordering.value;

    store
      .dispatch("api/apiRequest", getCampaignListModel)
      .then((response) => {
        campaignListTable.payload = response.data.payload;
        pagination.rows = response.data.payload.length;
        pagination.totalRows = response.data.filtered_record;
      })
      .catch((error) => {
        const errResp = error.data.error;

        if (errResp && errResp.http_status == 500) {
          isShowCreateBtn.value = false;
          openErrorModal(
            "เกิดข้อผิดพลาด",
            "ขออภัย แบรนด์นี้ไม่ได้ทำการเปิดใช้เมนู Upload Point กรุณาติดต่อ Choco CRM"
          );
        } else {
          openDefaultErrorModal(error);
        }
      })
      .finally(() => {
        loading.tableData = false;
      });
  };

  const fetchDeleteCampaign = (Campaign) => {
    openWarningModal(
      "ต้องการยกเลิกไฟล์อัปโหลด",
      `ต้องการยกเลิก ${Campaign.campaign_name} ใช่หรือไม่`,
      () => {
        deleteCampaignModel.payload.Campaign_Id = Campaign.campaign_id;
        store
          .dispatch("api/apiRequest", deleteCampaignModel)
          .then((response) => {
            openSuccessModal("ทำรายการสำเร็จ !", null, "ตกลง", () =>
              fetchCampaignList()
            );
          })
          .catch((error) => {
            loading.tableData = false;
            openErrorModal(error);
          })
          .finally(() => {});
      }
    );
  };

  const statusAction = reactive({
    CONFIRM: 1,
    APPROVE: 2,
    REJECT: 3,
  });

  const fetchAction = (campaign_id, action) => {
    let title;
    let description;
    let titleClass;
    if (statusAction.APPROVE == action) {
      title = "ยืนยันการทำรายกาาร";
      description =
        "<div>หากคุณยืนยันทำรายการอัปโหลดคะแนนแล้ว</div><div>จะไม่สามารถยกเลิกได้ภายหลัง</div>";
      titleClass = "text-success";
    } else {
      title = "ต้องการยกเลิกไฟล์อัปโหลด";
      description = "ต้องการยกเลิกใช่ หรือไม่";
      titleClass = "text-danger";
    }
    openWarningModal(
      title,
      description,
      () => {
        actionCampaignModel.payload.Campaign_Id = campaign_id;
        actionCampaignModel.payload.Action_Id = action;
        store
          .dispatch("api/apiRequest", actionCampaignModel)
          .then((response) => {
            openSuccessModal(
              "ทำรายการสำเร็จ !",
              null,
              "ตกลง",
              () => fetchCampaignList(),
              () => fetchCampaignList()
            );
          })
          .catch((error) => {
            loading.tableData = false;
            openErrorModal(error);
          })
          .finally(() => {});
      },
      null,
      null,
      "",
      false,
      false,
      titleClass
    );
  };

  const onClickAddData = () => {
    router.push("/point-exchange/upload-point/upload-point-create");
  };

  watch(
    pagination,
    () => {
      if (!loading.tableData) {
        fetchCampaignList();
      }
    },
    { deep: true }
  );

  watch(
    [filters, ordering],
    () => {
      pagination.currentPage = 1;

      fetchCampaignList();
    },
    { deep: true }
  );

  onBeforeMount(() => {
    fetchCampaignList();
  });

  return {
    loading,
    optionData,
    fields,
    statusOption,
    status,
    statusAction,
    pagination,
    onPageChange,
    onFilterEntity,
    sortingChanged,
    onSetValueSearch,
    onSelectFilter,

    campaignListTable,
    resolveDateWithSeperator,
    resolveTime,
    resolveUploadPointStatus,
    resolveClassUploadPointStatus,
    draftActionList,
    successActionList,
    resolveMappingTableAction,
    fetchAction,
    onClickAddData,
  };
}
